import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const Alert = () => {
  const alerts = useSelector((state) => state.alerts);
  return (
    <>
      {alerts && alerts.length > 0 && (
        <>
          {alerts.map((alert) => (
            <div className={`alert alert-${alert.alertType}  `} key={alert.id}>
              {alert.message}
            </div>
          ))}
        </>
      )}
    </>
  );
};
export default Alert;
